export const RAFFLE_ADMIN_STATUS_LABEL: Record<string, string> = {
  OPEN: 'Open',
  READY_TO_DRAW: 'Ready to draw',
  DRAWING: 'Drawing',
  COMPLETED: 'Complete',
};

export function canRemoveAdminRaffleTicket(status: string) {
  return status === 'OPEN' || status === 'READY_TO_DRAW';
}

export function clampRaffleWinnerCount(value: number, entryCount: number) {
  const max = Math.max(1, entryCount);
  if (!Number.isFinite(value)) {
    return 1;
  }
  return Math.min(max, Math.max(1, Math.trunc(value)));
}

export function isAdminRaffleTicketDimmed({
  status,
  submissionId,
  remainingIds,
  winnerIds,
}: {
  status: string;
  submissionId: string;
  remainingIds: readonly string[];
  winnerIds: readonly string[];
}) {
  if (status === 'DRAWING') {
    return !remainingIds.includes(submissionId);
  }
  if (status === 'COMPLETED') {
    return !winnerIds.includes(submissionId);
  }
  return false;
}

export function isAdminRaffleTicketWinner({
  status,
  submissionId,
  winnerIds,
}: {
  status: string;
  submissionId: string;
  winnerIds: readonly string[];
}) {
  return status === 'COMPLETED' && winnerIds.includes(submissionId);
}
